export const toggleCriteriaSelectedValue = (
    selectedValues: string[],
    value: string,
    isSelected: boolean
): string[] => (isSelected ? selectedValues.filter((val) => val !== value) : [...selectedValues, value]);

export const formatSelectedCriteriaNames = (criteriaTypeValues: any[], selected: any[]): string => {
    const selectedNames = (criteriaTypeValues || [])
        .filter((criteriaTypeValue: any) => selected.includes(criteriaTypeValue.value))
        .map((criteriaTypeValue: any) => criteriaTypeValue.name);

    if (selectedNames.length > 2) {
        return `${selectedNames.slice(0, 2).join(', ')} +${selectedNames.length - 2} `;
    }
    return selectedNames.join(', ');
};
